export default function UpdateInstanceModal({artefact, show, onHide}) {

}